import { render, staticRenderFns } from "./WatchDecision.vue?vue&type=template&id=076e36cc&"
import script from "./WatchDecision.vue?vue&type=script&lang=js&"
export * from "./WatchDecision.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports